module.exports = __webpack_public_path__ + "static/media/rd-modal-close.3676fb15.svg";